import { useRef, useEffect, useState } from "react";

import * as s from "./HeaderNavBarStyled";
import UserProfile from "./sub/UserProfile";
import * as mediaQuery from "components/MediaQuery";
import type { RoutesProps } from "api/interfaces/menuInterface.interface";
import { isNil } from "lodash";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { MdMenu } from "react-icons/md";
import { ScreenRecorder } from "../screenrecorder";
import ScreenRecordingInit from "../screenrecorder/ScreenRecordingInit";
import { ReactMediaRecorderHookProps } from "react-media-recorder";
import { useProSidebar } from "react-pro-sidebar";
import Notification from "./sub/notification/NotificationContainer";
import { useNoticeHeight } from "components/NoticePovider";
import SubMenuContainer from "./sub/SubMenuContainer";
import { useMenu } from "hook/useMenu";

export enum SCREEN_RECORDER_STATE {
  RECORDING = "RECORDING",
  STOPPED = "STOPPED",
  ERROR = "ERROR",
  INIT = "INIT",
}

type HeaderNavBarProps = {
  buttonRef?: any;
};

function HeaderNavBar({ buttonRef }: HeaderNavBarProps): JSX.Element {
  // console.log(menu);

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [status, setStatus] = useState<SCREEN_RECORDER_STATE | null>(null);
  const { collapsed, collapseSidebar } = useProSidebar();
  const { noticeHeight } = useNoticeHeight();
  const { currentMenu } = useMenu({});

  const startScreenRecording = useRef<(() => void) | null>(null);
  const stopScreenRecording = useRef<(() => void) | null>(null);

  const [screenRecorderOptions, setScreenRecorderOptions] =
    useState<ReactMediaRecorderHookProps | null>(null);

  const resetScreenRecorder = () => {
    setStatus(null);
    setScreenRecorderOptions(null);
    startScreenRecording.current = null;
    stopScreenRecording.current = null;
  };
  //권한 변경 체크
  const listenChangePermission = async () => {
    const permission = await navigator.permissions.query({
      name: "microphone" as PermissionName,
    });
    permission.addEventListener("change", () => {
      if (status !== SCREEN_RECORDER_STATE.RECORDING) {
        window.location.reload();
      }
    });
  };

  useEffect(() => {
    if (
      screenRecorderOptions &&
      screenRecorderOptions.screen &&
      status === SCREEN_RECORDER_STATE.INIT &&
      startScreenRecording.current
    ) {
      setStatus(SCREEN_RECORDER_STATE.RECORDING);
      startScreenRecording.current();
    }
  }, [screenRecorderOptions?.screen, startScreenRecording.current]);
  useEffect(() => {
    listenChangePermission();
  }, []);

  return (
    <s.HeaderContainer
      level={selectedAccount.accountLevel}
      isCollapsed={collapsed}
      noticeHeight={noticeHeight}
      as="header"
    >
      <s.Inner>
        <mediaQuery.Mobile>
          <button
            onClick={() => {
              collapseSidebar();
            }}
            className="sidebar-collapse-button"
            data-testid="blocks-headernav-headernav-button-collapse-sidebar"
          >
            <MdMenu size={26} />
          </button>
        </mediaQuery.Mobile>
        <s.LeftWrapper>
          <s.Title
            onClick={() => window.location.reload()}
            level={selectedAccount.accountLevel}
            data-testid="blocks-headernav-headernav-title-reload"
          >
            {currentMenu?.name}
          </s.Title>
          <SubMenuContainer />
        </s.LeftWrapper>
        <s.RightContainer>
          <mediaQuery.Default>
            {status && screenRecorderOptions?.screen && (
              <ScreenRecorder
                startScreenRecording={startScreenRecording}
                stopScreenRecording={stopScreenRecording}
                screenRecorderOptions={screenRecorderOptions}
                onFinish={resetScreenRecorder}
              />
            )}
          </mediaQuery.Default>
          <Notification />
          <mediaQuery.Default>
            <UserProfile
              ref={buttonRef}
              onConfirmScreenRecording={() => {
                setStatus(SCREEN_RECORDER_STATE.INIT);
              }}
            />
          </mediaQuery.Default>
        </s.RightContainer>
      </s.Inner>
      {status === SCREEN_RECORDER_STATE.INIT && (
        <ScreenRecordingInit
          setScreenRecorderOptions={(options) => {
            setScreenRecorderOptions(options);
          }}
          setStatus={setStatus}
        />
      )}
    </s.HeaderContainer>
  );
}

export default HeaderNavBar;
